import * as Yup from 'yup';

export const MAX_NOTES_LENGTH = 2000;
export const MAX_TAG_NAME_LENGTH = 64;

export const notesValidation = Yup.string().max(
  MAX_NOTES_LENGTH,
  `Notes must be ${MAX_NOTES_LENGTH} characters or fewer`,
);

const tagName = tag => (typeof tag === 'string' ? tag : tag?.name || '').trim();

export const tagsValidation = Yup.array().test(
  'tag-name-length',
  `New tags must be ${MAX_TAG_NAME_LENGTH} characters or fewer`,
  tags => (tags || []).every(tag => tag?.id || tagName(tag).length <= MAX_TAG_NAME_LENGTH),
);
